import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ISSUE_PARAM } from '@/tracker/config/urls';

/** Карточка задачи открыта, пока в URL есть ?issue=KEY: ссылкой можно делиться, «Назад» закрывает */
export const useIssueDrawer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const issueKey = searchParams.get(ISSUE_PARAM);

  const openIssue = useCallback(
    (key: string) =>
      setSearchParams((params) => {
        params.set(ISSUE_PARAM, key);

        return params;
      }),
    [setSearchParams],
  );

  const closeIssue = useCallback(
    () =>
      setSearchParams((params) => {
        params.delete(ISSUE_PARAM);

        return params;
      }),
    [setSearchParams],
  );

  /** Для <Link to>: текущая страница + ?issue=KEY */
  const issueLink = useCallback(
    (key: string) => {
      const params = new URLSearchParams(searchParams);

      params.set(ISSUE_PARAM, key);

      return { search: `?${params}` };
    },
    [searchParams],
  );

  return { issueKey, openIssue, closeIssue, issueLink };
};
